import { create } from "zustand";

import { STRINGS } from "../utils/strings";

const initialState = {
  data: [],
  loading: false,
  currentPage: STRINGS.DEFAULT_PAGE,
  resLimit: STRINGS.DEFAULT_PAGINATION_LIMIT,
  resultCount: 0,
  selectedContract: null,
};

export const useContractStore = create((set) => ({
  ...initialState,

  setData: (data) => set({ data }),
  setLoading: (loading) => set({ loading }),
  setCurrentPage: (page) => set({ currentPage: page }),
  setResLimit: (limit) => set({ resLimit: limit }),
  setResultCount: (count) => set({ resultCount: count }),
  setSelectedContract: (value) => set({ selectedContract: value }),

  resetCurrentPage: () => set({ currentPage: 1 }),
  reset: () => set(initialState),
}));
